import React from "react";
import { useNavigate, Link } from "react-router-dom";
import "../App.css";
import { ROUTES, LEGAL } from "../config/constants";

const CURRENT_YEAR = new Date().getFullYear();

/**
 * Page des mentions légales
 * Contient toutes les informations légales requises pour l'application
 */
function MentionsLegales() {
  const navigate = useNavigate();

  return (
    <div className="page-container" style={{ padding: "2rem 1rem" }}>
      <div
        className="card"
        style={{
          maxWidth: "900px",
          margin: "0 auto",
          padding: "2rem",
          textAlign: "left",
        }}
      >
        <div
          style={{
            marginBottom: "2rem",
            padding: "1rem 1.25rem",
            background: "var(--bg-secondary, rgba(0,0,0,0.03))",
            borderRadius: "8px",
            borderLeft: "4px solid var(--primary, #9147ff)",
            fontSize: "0.95rem",
            color: "var(--text-muted)",
          }}
        >
          <strong>© {CURRENT_YEAR} — Tous droits réservés.</strong> L'ensemble du site, de son
          contenu et de ses fonctionnalités est protégé par le droit d'auteur et la propriété
          intellectuelle. Toute reproduction ou utilisation non autorisée est interdite.
        </div>

        <h1 className="card-title" style={{ marginBottom: "2rem" }}>
          Mentions Légales
        </h1>

        <section style={{ marginBottom: "2rem" }}>
          <h2 style={{ fontSize: "1.5rem", marginBottom: "1rem", color: "var(--primary)" }}>
            1. Informations légales
          </h2>
          <p style={{ marginBottom: "0.5rem", lineHeight: "1.6" }}>
            <strong>Éditeur du site :</strong>
          </p>
          <p style={{ marginBottom: "1rem", lineHeight: "1.6", color: "var(--text-muted)" }}>
            {LEGAL.COMPANY_NAME}
            {LEGAL.ADDRESS && (
              <>
                <br />
                {LEGAL.ADDRESS}
              </>
            )}
            <br />
            SIRET : {LEGAL.SIRET}
            <br />
            Email :{" "}
            <a
              href={`mailto:${LEGAL.CONTACT_EMAIL}`}
              style={{ color: "var(--primary)", textDecoration: "underline" }}
            >
              {LEGAL.CONTACT_EMAIL}
            </a>
          </p>

          <p style={{ marginBottom: "0.5rem", lineHeight: "1.6" }}>
            <strong>Directeur de publication :</strong>
          </p>
          <p style={{ marginBottom: "1rem", lineHeight: "1.6", color: "var(--text-muted)" }}>
            {LEGAL.COMPANY_NAME}
          </p>

          <p style={{ marginBottom: "0.5rem", lineHeight: "1.6" }}>
            <strong>Hébergeur :</strong>
          </p>
          <p style={{ marginBottom: "1rem", lineHeight: "1.6", color: "var(--text-muted)" }}>
            OVH SAS
            <br />
            2 rue Kellermann, 59100 Roubaix, France
            <br />
            Téléphone : 1007 (depuis la France) ou +33 9 72 10 10 07
          </p>
        </section>

        <section style={{ marginBottom: "2rem" }}>
          <h2 style={{ fontSize: "1.5rem", marginBottom: "1rem", color: "var(--primary)" }}>
            2. Protection des données personnelles
          </h2>
          <p style={{ marginBottom: "1rem", lineHeight: "1.6" }}>
            Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi
            Informatique et Libertés, vous disposez des droits suivants sur vos données
            personnelles : droit d&apos;accès, de rectification, d&apos;effacement (art. 17 RGPD),
            d&apos;opposition et de portabilité.
          </p>

          <h3 style={{ fontSize: "1.2rem", marginTop: "1.5rem", marginBottom: "0.5rem" }}>
            2.1 Données collectées et finalités
          </h3>
          <p style={{ marginBottom: "1rem", lineHeight: "1.6" }}>
            Nous collectons : adresse email, pseudo Twitch, préférences de configuration,
            historique d&apos;utilisation du service (commandes, récompenses, classements). Ces
            données sont utilisées pour la fourniture du service, sa personnalisation et des
            statistiques internes.
          </p>

          <h3 style={{ fontSize: "1.2rem", marginTop: "1.5rem", marginBottom: "0.5rem" }}>
            2.2 Droits RGPD et suppression de compte
          </h3>
          <p style={{ marginBottom: "1rem", lineHeight: "1.6" }}>
            Vous pouvez supprimer votre compte et toutes les données associées directement depuis
            votre espace personnel :{" "}
            <Link to={ROUTES.DASHBOARD} style={{ color: "var(--primary)", textDecoration: "underline" }}>
              Paramètres → Mon compte → Supprimer mon compte
            </Link>
            . Les demandes par email sont traitées dans un délai maximal de 30 jours.
          </p>

          <p style={{ marginBottom: "1rem", lineHeight: "1.6" }}>
            Les données collectées sont utilisées uniquement dans le cadre de l&apos;utilisation du
            service et ne sont en aucun cas transmises à des tiers à des fins commerciales.
          </p>
          <p style={{ marginBottom: "1rem", lineHeight: "1.6" }}>
            Pour exercer vos droits ou toute question relative à vos données, contactez-nous à :{" "}
            <strong>
              <a
                href={`mailto:${LEGAL.CONTACT_EMAIL}`}
                style={{ color: "var(--primary)", textDecoration: "underline" }}
              >
                {LEGAL.CONTACT_EMAIL}
              </a>
            </strong>
          </p>
        </section>

        <section style={{ marginBottom: "2rem" }}>
          <h2 style={{ fontSize: "1.5rem", marginBottom: "1rem", color: "var(--primary)" }}>
            3. Utilisation des services tiers
          </h2>
          <p style={{ marginBottom: "1rem", lineHeight: "1.6" }}>
            Cette application utilise les services suivants :
          </p>
          <ul style={{ marginLeft: "2rem", marginBottom: "1rem", lineHeight: "1.8" }}>
            <li>
              <strong>Twitch API :</strong> Pour l'intégration avec la plateforme Twitch. L'utilisation
              est soumise aux{" "}
              <a
                href="https://www.twitch.tv/p/legal/terms-of-service/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "var(--primary)", textDecoration: "underline" }}
              >
                Conditions d'utilisation de Twitch
              </a>
              .
            </li>
            <li>
              <strong>Spotify API :</strong> Pour l'intégration avec la plateforme Spotify. L'utilisation
              est soumise aux{" "}
              <a
                href="https://www.spotify.com/legal/end-user-agreement/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "var(--primary)", textDecoration: "underline" }}
              >
                Conditions d'utilisation de Spotify
              </a>
              .
            </li>
          </ul>
          <p style={{ marginBottom: "1rem", lineHeight: "1.6" }}>
            En utilisant cette application, vous acceptez également les conditions d'utilisation de ces
            services tiers.
          </p>
        </section>

        <section style={{ marginBottom: "2rem" }}>
          <h2 style={{ fontSize: "1.5rem", marginBottom: "1rem", color: "var(--primary)" }}>
            4. Propriété intellectuelle et droits réservés
          </h2>
          <p style={{ marginBottom: "1rem", lineHeight: "1.6" }}>
            <strong>© {CURRENT_YEAR} — Tous droits réservés.</strong> L'ensemble de ce site relève
            de la législation française et internationale sur le droit d'auteur et la propriété
            intellectuelle. Tous les droits de reproduction, de représentation, d'adaptation et
            d'exploitation sont réservés, y compris pour les documents téléchargeables, les
            représentations iconographiques et photographiques, le code source et les marques.
          </p>
          <p style={{ marginBottom: "1rem", lineHeight: "1.6" }}>
            La reproduction, la représentation ou l'exploitation de tout ou partie de ce site sur
            un support électronique ou physique quel qu'il soit est formellement interdite sauf
            autorisation expresse et écrite de l'éditeur.
          </p>
        </section>

        <section style={{ marginBottom: "2rem" }}>
          <h2 style={{ fontSize: "1.5rem", marginBottom: "1rem", color: "var(--primary)" }}>
            5. Responsabilité
          </h2>
          <p style={{ marginBottom: "1rem", lineHeight: "1.6" }}>
            L'éditeur du site s'efforce d'assurer l'exactitude et la mise à jour des informations
            diffusées sur le site, dont il se réserve le droit de corriger, à tout moment et sans
            préavis, le contenu.
          </p>
          <p style={{ marginBottom: "1rem", lineHeight: "1.6" }}>
            Toutefois, l'éditeur ne peut garantir l'exactitude, la précision ou l'exhaustivité des
            informations mises à disposition sur le site. En conséquence, l'éditeur décline toute
            responsabilité :
          </p>
          <ul style={{ marginLeft: "2rem", marginBottom: "1rem", lineHeight: "1.8" }}>
            <li>pour toute interruption du site ou du service</li>
            <li>pour toute survenance de bugs</li>
            <li>pour toute erreur ou omission</li>
            <li>pour tout dommage résultant d'une intrusion frauduleuse d'un tiers</li>
            <li>pour tout dommage résultant d'une utilisation inappropriée du service</li>
          </ul>
        </section>

        <section style={{ marginBottom: "2rem" }}>
          <h2 style={{ fontSize: "1.5rem", marginBottom: "1rem", color: "var(--primary)" }}>
            6. Cookies
          </h2>
          <p style={{ marginBottom: "1rem", lineHeight: "1.6" }}>
            Ce site utilise des cookies pour améliorer l'expérience utilisateur et assurer le
            bon fonctionnement du service. Les cookies sont utilisés pour :
          </p>
          <ul style={{ marginLeft: "2rem", marginBottom: "1rem", lineHeight: "1.8" }}>
            <li>Maintenir votre session utilisateur</li>
            <li>Stocker vos préférences de connexion</li>
            <li>Assurer la sécurité de l'application</li>
          </ul>
          <p style={{ marginBottom: "1rem", lineHeight: "1.6" }}>
            En continuant à utiliser ce site, vous acceptez l'utilisation de cookies conformément
            à notre politique de cookies.
          </p>
        </section>

        <section style={{ marginBottom: "2rem" }}>
          <h2 style={{ fontSize: "1.5rem", marginBottom: "1rem", color: "var(--primary)" }}>
            7. Droit applicable et juridiction compétente
          </h2>
          <p style={{ marginBottom: "1rem", lineHeight: "1.6" }}>
            Les présentes mentions légales sont régies par le droit français. En cas de litige et
            à défaut d'accord amiable, le litige sera porté devant les tribunaux français
            conformément aux règles de compétence en vigueur.
          </p>
        </section>

        <section style={{ marginBottom: "2rem" }}>
          <h2 style={{ fontSize: "1.5rem", marginBottom: "1rem", color: "var(--primary)" }}>
            8. Contact
          </h2>
          <p style={{ marginBottom: "1rem", lineHeight: "1.6" }}>
            Pour toute question concernant ces mentions légales ou le service, vous pouvez nous
            contacter à l&apos;adresse suivante : <strong><a href={`mailto:${LEGAL.CONTACT_EMAIL}`}>{LEGAL.CONTACT_EMAIL}</a></strong>
          </p>
        </section>

        <div
          style={{
            marginTop: "2.5rem",
            paddingTop: "1.5rem",
            borderTop: "1px solid var(--border-color, rgba(0,0,0,0.08))",
            textAlign: "center",
            fontSize: "0.9rem",
            color: "var(--text-muted)",
          }}
        >
          <p style={{ marginBottom: "1.5rem" }}>
            © {CURRENT_YEAR} — Tous droits réservés.
          </p>
          <button
            className="button"
            onClick={() => navigate("/")}
            style={{ padding: "1rem 2rem", fontSize: "1rem" }}
          >
            Retour à l'accueil
          </button>
        </div>
      </div>
    </div>
  );
}

export default MentionsLegales;
